"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => {};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;

/** Keep JavaScript-only interactions disabled until their handlers are ready. */
export function useHydrated() {
	return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
}
